import { generateID } from "../../helpers/generateID";
import { BracketsItem, ItemI, PartInterface, partsProperties } from "../../../shared";
import { StoreWallInterface } from "../../types/store";
import { useStoreRoom } from "../../useStoreRoom";
import { getItemFillingRangesNew } from "../../helpers/getItemFillingRangesNew";
import { useStoreSystem } from "../../useStoreSystem";
import { updateItemNameWithNomenclature } from "../../helpers/getItemNomenclatureName";
import { isBracket, isAmplifier, isEdge, isNotServicePart, isPunchPanel, isRod } from "../../../utils/typeChecker";

interface IncomingPropsInterface {
    currentShelving: StoreWallInterface;
    editSectionID: string;
    newItem: ItemI;
    newY?: number;
}
//бывший addItem
export const getShelfWithNewItem = ({ currentShelving, editSectionID, newItem, newY }: IncomingPropsInterface) => {
    const newCurrentShelf = structuredClone(currentShelving);

    const id = generateID();
    const parts = useStoreSystem.getState().parts;
    const currentSectionIndex = currentShelving.sections.findIndex((section) => section.id === editSectionID);
    const currentSection = currentShelving.sections[currentSectionIndex];
    const prevSection = currentShelving.sections[currentSectionIndex - 1];
    const nextSection = currentShelving.sections[currentSectionIndex + 1];
    const model = newItem.PROPERTIES.FILE_3D;
    const price = Number(newItem.PRICE) || 0;
    //FIXME почему "-2"?
    const x = (currentSection.offset - 2) / 1000 + +newItem.PROPERTIES.LENGTH / 2000;
    const itemHeight = parseFloat(newItem.PROPERTIES.HEIGHT) || 0;
    const minHeight =
        (useStoreRoom.getState().height -
            currentShelving.offsetCeiling -
            Math.min(currentSection.leftRackHeight, currentSection.height)) /
        1000;

    //FIXME почему "/50"?
    const values = new Array(Math.ceil(currentShelving.height / 50))
        .fill(undefined)
        .map((value, index) => Math.trunc((minHeight + 0.05 * index) * 1000) / 1000);

    const availablePoints =
        getItemFillingRangesNew({ sections: currentShelving.sections, item: newItem }).find(
            (section) => section.id === currentSection.id
        )?.points || [];

    const shelfY = !!availablePoints.length ? Math.min(...availablePoints) : Math.min(...values);

    const currentBrackets =
        parts?.filter((part) => {
            return (
                newItem.PARTS &&
                newItem.PARTS.find((itemPart) => +part.ID === +itemPart && part.TYPE && isBracket(part.TYPE))
            );
        }) ?? [];

    const currentParts =
        parts?.filter((part) => {
            return (
                newItem.PARTS &&
                newItem.PARTS.find((itemPart) => +part.ID === +itemPart && part.TYPE && isNotServicePart(part.TYPE))
            );
        }) ?? [];

    const isPunchPanelItem = isPunchPanel(newItem.TYPE);
    console.log("Item type:", newItem.TYPE, "isPunchPanel:", isPunchPanelItem, "Item name:", newItem.NAME);
    const depthOffset = 0;
    const position = [x, shelfY, +newItem.PROPERTIES.DEPTH / 2000 + depthOffset];
    console.log("Position for item:", newItem.NAME, "z-coordinate:", position[2]);
    const positionLeftBracket = [currentSection.offset / 1000, shelfY, 0];
    const positionRightBracket = [
        (currentSection.offset - partsProperties.railing.vertical.doubleWidth) / 1000 + currentSection.width / 1000,
        shelfY,
        0,
    ];

    const elements = currentBrackets.map((bracket) => {
        const holes = bracket?.PROPERTIES?.RAIL_HOLES;
        return {
            bitrixId: bracket?.BITRIX_OFFER_ID || "",
            model: bracket?.PROPERTIES.FILE_3D || "",
            modelId: bracket?.ID || "",
            name: bracket?.NAME,
            type: bracket?.TYPE,
            price: Number(bracket?.PRICE) || 0,
            railHoles:
                holes &&
                holes.map((hole) => ({
                    leftRightRail: hole.leftRightRail === "Y",
                    leftLeftRail: hole.leftLeftRail === "Y",
                    rightLeftRail: hole.rightLeftRail === "Y",
                    rightRightRail: hole.rightRightRail === "Y",
                    depthFrom: +hole.depthFrom,
                    depthTo: +hole.depthTo,
                    sort: +hole.sort,
                })),
        };
    });

    const newBrackets: BracketsItem = {
        left: {
            elements: elements,
            isVisible: true,
            position: positionLeftBracket,
        },
        right: {
            elements: elements,
            isVisible: true,
            position: positionRightBracket,
        },
        isExist: !!currentBrackets[0]?.PROPERTIES.FILE_3D,
    };

    const positionLeftAmp = [currentSection.offset / 1000, shelfY, 0];
    const positionRightAmp = [
        (currentSection.offset - partsProperties.railing.vertical.doubleWidth) / 1000 + currentSection.width / 1000,
        shelfY,
        0,
    ];

    const currentAmps =
        parts?.filter((part) => {
            return (
                newItem.PARTS &&
                newItem.PARTS.find((itemPart) => +part.ID === +itemPart && part.TYPE && isAmplifier(part.TYPE))
            );
        }) ?? [];

    const elementsAmps = currentAmps.map((amp) => {
        const holes = amp?.PROPERTIES?.RAIL_HOLES;
        return {
            bitrixId: amp?.BITRIX_OFFER_ID || "",
            model: amp?.PROPERTIES.FILE_3D || "",
            modelId: amp?.ID || "",
            name: amp?.NAME,
            type: amp?.TYPE,
            price: Number(amp?.PRICE) || 0,
            picture: amp?.PICTURE,
            railHoles:
                holes &&
                holes.map((hole) => ({
                    leftRightRail: hole.leftRightRail === "Y",
                    leftLeftRail: hole.leftLeftRail === "Y",
                    rightLeftRail: hole.rightLeftRail === "Y",
                    rightRightRail: hole.rightRightRail === "Y",
                    depthFrom: +hole.depthFrom,
                    depthTo: +hole.depthTo,
                    sort: +hole.sort,
                })),
        };
    });

    const newAmps: BracketsItem = {
        left: {
            elements: elementsAmps,
            isVisible: true,
            position: positionLeftAmp,
        },
        right: {
            elements: elementsAmps,
            isVisible: true,
            position: positionRightAmp,
        },
        isExist: !!currentAmps[0]?.PROPERTIES.FILE_3D,
    };

    const currentRods =
        parts?.filter((part) => {
            return (
                newItem.PARTS &&
                newItem.PARTS.find((itemPart) => +part.ID === +itemPart && part.TYPE && isRod(part.TYPE))
            );
        }) ?? [];

    const newRods: PartInterface[] = currentRods.map((rod) => {
        const holes = rod?.PROPERTIES?.RAIL_HOLES;
        return {
            isVisible: !!rod?.PROPERTIES.FILE_3D,
            bitrixId: rod?.BITRIX_OFFER_ID || "",
            model: rod?.PROPERTIES.FILE_3D || "",
            modelId: rod?.ID || "",
            name: rod?.NAME,
            type: rod?.TYPE,
            price: Number(rod?.PRICE) || 0,
            picture: rod?.PICTURE,
            railHoles:
                holes &&
                holes.map((hole) => ({
                    leftRightRail: hole.leftRightRail === "Y",
                    leftLeftRail: hole.leftLeftRail === "Y",
                    rightLeftRail: hole.rightLeftRail === "Y",
                    rightRightRail: hole.rightRightRail === "Y",
                    depthFrom: +hole.depthFrom,
                    depthTo: +hole.depthTo,
                    sort: +hole.sort,
                })),
            position: [
                currentSection.offset / 1000 + currentSection.width / 2000,
                shelfY,
                Number(newItem?.PROPERTIES?.DEPTH) / 2000 || 0.5,
            ],
        };
    });

    const currentEdges =
        parts?.filter((part) => {
            return (
                newItem.PARTS &&
                newItem.PARTS.find((itemPart) => +part.ID === +itemPart && part.TYPE && isEdge(part.TYPE))
            );
        }) ?? [];

    const newEdges: PartInterface[] = currentEdges.map((edge) => {
        const holes = edge?.PROPERTIES?.RAIL_HOLES;
        return {
            isVisible: !!edge?.PROPERTIES.FILE_3D,
            bitrixId: edge?.BITRIX_OFFER_ID || "",
            model: edge?.PROPERTIES.FILE_3D || "",
            modelId: edge?.ID || "",
            name: edge?.NAME,
            type: edge?.TYPE,
            price: Number(edge?.PRICE) || 0,
            picture: edge?.PICTURE,
            railHoles:
                holes &&
                holes.map((hole) => ({
                    leftRightRail: hole.leftRightRail === "Y",
                    leftLeftRail: hole.leftLeftRail === "Y",
                    rightLeftRail: hole.rightLeftRail === "Y",
                    rightRightRail: hole.rightRightRail === "Y",
                    depthFrom: +hole.depthFrom,
                    depthTo: +hole.depthTo,
                    sort: +hole.sort,
                })),
            position: [
                currentSection.offset / 1000 + currentSection.width / 2000,
                shelfY,
                Number(newItem?.PROPERTIES?.DEPTH) / 2000 || 0.25,
            ],
        };
    });

    const newParts: PartInterface[] = currentParts.map((part) => {
        const holes = part?.PROPERTIES?.RAIL_HOLES;
        return {
            isVisible: !!part?.PROPERTIES.FILE_3D,
            bitrixId: part?.BITRIX_OFFER_ID || "",
            model: part?.PROPERTIES.FILE_3D || "",
            modelId: part?.ID || "",
            name: part?.NAME,
            type: part?.TYPE,
            price: Number(part?.PRICE) || 0,
            railHoles:
                holes &&
                holes.map((hole) => ({
                    leftRightRail: hole.leftRightRail === "Y",
                    leftLeftRail: hole.leftLeftRail === "Y",
                    rightLeftRail: hole.rightLeftRail === "Y",
                    rightRightRail: hole.rightRightRail === "Y",
                    depthFrom: +hole.depthFrom,
                    depthTo: +hole.depthTo,
                    sort: +hole.sort,
                })),
            //FIXME почему "0.25"?
            position: [
                currentSection.offset / 1000 + currentSection.width / 2000,
                shelfY,
                Number(newItem?.PROPERTIES?.DEPTH) / 2000 || 0.25,
            ],
        };
    });

    prevSection?.items.forEach((item) => {
        if (Math.abs(item.position[1] - shelfY) < 0.01) {
            if (+newItem.PROPERTIES.DEPTH > item.depth) {
                newCurrentShelf.sections[currentSectionIndex - 1].items = currentShelving.sections[
                    currentSectionIndex - 1
                ].items.map((prevSectionItem) => {
                    if (prevSectionItem.id === item.id) {
                        //TODO может выкинуть отсюда деньги
                        newCurrentShelf.price.current -= prevSectionItem.brackets.right.elements.reduce(
                            (sum, element) => sum + element.price,
                            0
                        );
                        return {
                            ...prevSectionItem,
                            brackets: {
                                ...prevSectionItem.brackets,
                                right: { ...prevSectionItem.brackets.right, isVisible: false },
                            },
                        };
                    }
                    return prevSectionItem;
                });
                newBrackets.left.isVisible = true;
            } else {
                newBrackets.left.isVisible = !item.brackets.right.isVisible;
            }
        }
    });

    nextSection?.items.forEach((item) => {
        if (Math.abs(item.position[1] - shelfY) < 0.01) {
            if (+newItem.PROPERTIES.DEPTH > item.depth) {
                newCurrentShelf.sections[currentSectionIndex + 1].items = currentShelving.sections[
                    currentSectionIndex + 1
                ].items.map((nextSectionItem) => {
                    if (nextSectionItem.id === item.id) {
                        newCurrentShelf.price.current -= nextSectionItem.brackets.left.elements.reduce(
                            (sum, element) => sum + element.price,
                            0
                        );
                        return {
                            ...nextSectionItem,
                            brackets: {
                                ...nextSectionItem.brackets,
                                left: { ...nextSectionItem.brackets.left, isVisible: false },
                            },
                        };
                    }
                    return nextSectionItem;
                });
                newBrackets.right.isVisible = true;
            } else {
                newBrackets.right.isVisible = !item.brackets.left.isVisible;
            }
        }
    });

    const railHoles =
        newItem?.PROPERTIES?.RAIL_HOLES &&
        newItem?.PROPERTIES?.RAIL_HOLES.map((hole) => ({
            leftRightRail: hole.leftRightRail === "Y",
            leftLeftRail: hole.leftLeftRail === "Y",
            rightLeftRail: hole.rightLeftRail === "Y",
            rightRightRail: hole.rightRightRail === "Y",
            depthFrom: +hole.depthFrom,
            depthTo: +hole.depthTo,
            sort: +hole.sort,
        }));

    let currentItem = {
        width: +newItem.PROPERTIES.LENGTH,
        height: itemHeight,
        depth: +newItem.PROPERTIES.DEPTH,
        railHoles: railHoles,
        model: model,
        modelId: newItem.ID,
        sectionID: editSectionID,
        position,
        id,
        price,
        type: newItem?.TYPE || [],
        bitrixId: newItem.BITRIX_OFFER_ID,
        bitrixIdAlt: newItem.BITRIX_OFFER_ID_ALT,
        brackets: newBrackets,
        amps: newAmps,
        rods: newRods,
        edges: newEdges,
        parts: newParts,
        name: newItem.NAME,
    };

    // Обновляем название на основе номенклатуры, если есть альтернативный ID
    if (newItem.BITRIX_OFFER_ID_ALT) {
        const updatedItem = updateItemNameWithNomenclature(currentItem, newItem);
        currentItem.name = updatedItem.name;
    }

    newCurrentShelf.sections[currentSectionIndex].items.push({
        ...currentItem,
        position: [currentItem.position[0], shelfY, currentItem.position[1]],
    });

    return newCurrentShelf;
};
